import { ImportCSVBookingField } from '@components/process-import-csv/process-import-csv.type';
import { ADMISSION_TYPE_BOTTLE_SERVICE, ADMISSION_TYPE_TICKET } from '@domain/admission';

import { isEmailValidator } from './utils/is-email-validator';
import { isEmptyValidator } from './utils/is-empty-validator';
import { isIsoCodeValidator } from './utils/is-iso-code-validator';

export const CheckSiaeAdmissionTypes = [ADMISSION_TYPE_BOTTLE_SERVICE, ADMISSION_TYPE_TICKET];

export const FIELD_QR_CODE = 'qrCode';

export const FIELD_FIRST_NAME = 'firstName';

export const FIELD_LAST_NAME = 'lastName';

export const FIELD_EMAIL = 'email';

export const FIELD_FULL_NAME = 'fullName';

export const FIELD_PHONE = 'phone';

export const FIELD_LANGUAGE = 'language';

export const FIELD_NATIONALITY = 'nationality';

export const FIELD_TAX_ID_PT = 'taxIdPt';

export const ERROR_EMPTY_MESSAGE = 'errors:allColumnEmptyRows';

export const ERROR_COLUMN_MESSAGE = 'errors:columnMessage';

export const ERROR_MESSAGE = 'errors:errorMessage';

export const bookingFields: ImportCSVBookingField[] = [
  {
    // No blocking rule: format problems in this column surface as non-blocking warnings via
    // createQrCodeIssueLists, so a false positive cannot lock the operator out of the import.
    id: FIELD_QR_CODE,
  },
  {
    id: FIELD_FIRST_NAME,
    validationRules: (values: string[]) => isEmptyValidator(values),
    error: ERROR_EMPTY_MESSAGE,
  },
  {
    id: FIELD_LAST_NAME,
    validationRules: (values: string[]) => isEmptyValidator(values),
    error: ERROR_EMPTY_MESSAGE,
  },
  {
    id: FIELD_FULL_NAME,
    validationRules: (values: string[]) => isEmptyValidator(values),
    error: ERROR_EMPTY_MESSAGE,
  },
  {
    id: FIELD_EMAIL,
    validationRules: (values: string[]) => isEmailValidator(values),
    error: 'errors:allColumnEmails',
  },
  {
    id: FIELD_PHONE,
    validationRules: (values: string[]) => !isEmptyValidator(values),
    error: ERROR_EMPTY_MESSAGE,
  },
  {
    id: FIELD_LANGUAGE,
    validationRules: (values: string[]) => isIsoCodeValidator(values),
    error: 'errors:onlyIsoCodes',
  },
  {
    id: FIELD_NATIONALITY,
    validationRules: (values: string[]) => !isEmptyValidator(values),
    error: ERROR_EMPTY_MESSAGE,
  },
];
